module.exports = __webpack_public_path__ + "img/3_193.f1d23766.png";